import * as actionTypes from './actionTypes'

export function getProductInstanceConfig(instanceName: string, routePrefix: string) {
	let url = "productinstance";

	if (instanceName) {
		url += `?instanceName=${instanceName}`
	}

	if (routePrefix) {
		url += instanceName ? `&routePrefix=${routePrefix}` : `?routePrefix=${routePrefix}`;
	}
	return {
		type: actionTypes.PROCESS_PRODUCT_INSTANCE,
		payload: {
			request: {
				method: 'get',
				url: url,
			}
		}
	};
}

export function fetchDecisionSupportSessionOutput(decisionSupportSessionId: string) {
	return {
		type: actionTypes.GET_COMPLETED_DECISION_SUPPORT_SESSION_PAYLOAD,
		payload: {
			request: {
				method: 'get',
				url: `decisionsupportsession/${decisionSupportSessionId}`
			}
		}
	};
}

export function setSchedulingSessionFlowType(schedulingSessionFlowType: string) {
	return {
		type: actionTypes.SET_SCHEDULING_SESSION_FLOW_TYPE,
		schedulingSessionFlowType: schedulingSessionFlowType
	};
}

export function getPatientPools() {
	return {
		type: actionTypes.GET_PATIENT_POOLS,
		payload: {
			request: {
				method: 'get',
				url: `patientpools`
			}
		}
	};
}

export function resolveLocationEntryPoint(refType: string, refValue: string) {
	return {
		type: actionTypes.RESOLVE_LOCATION_ENTRY_POINT,
		payload: {
			request: {
				method: 'get',
				url: `start/locationLookup?refType=${encodeURIComponent(refType)}&refValue=${encodeURIComponent(refValue)}`
			}
		}
	};
}

export function setLocationEntryPoint(locationEntryPoint: {
	sites: { siteId: number; pmsId?: string | null; siteName?: string | null }[];
	patientPoolUniqueToken?: string | null;
	patientPoolDisplayName?: string | null;
	patientPoolPrefix?: string | null;
	isPatientPoolLocked?: boolean;
}) {
	return {
		type: actionTypes.SET_LOCATION_ENTRY_POINT,
		locationEntryPoint
	};
}

export function clearLocationEntryPoint() {
	return {
		type: actionTypes.CLEAR_LOCATION_ENTRY_POINT
	};
}
